// 传入明细控件做存储
class Container {
    // 被发送人
    _senderPerson = null
    //下一步审批人 (第一个审批人)
    _nextApprover = null
    constructor(detailControl) {
        this._detailControl = JSON.parse(JSON.stringify(detailControl))
    }

    convertToEnt() {
        let selector = []
        // let tempObj = {
        //     "datas": [
        //         {
        //             "name": "名称",
        //             "type": "selector table ...",
        //             "values": [],
        //             "value": "",
        //         }
        //     ]
        //
        //     // templateControl -> temp obj -> save -> new application -> get temp obj -> templateControl
        // }
    }

    /**
     * 创建table
     * @param options 选中的值
     */
    createTables(options){
        let results = []
        for (const option of options) {
            const result = this.buildTable(option)
            results.push(result)
        }
        return results
    }

    buildTable(name){
        let control = JSON.parse(JSON.stringify(this._detailControl))
        control.Property.Title[0].Text = name
        // 设置子元素必填
        let children = control.Config.Table.Children
        for (const child of children) {
            child.Property.Require = 1
        }
        return control
    }

    /**
     * 全部填写?
     * @return {boolean}
     */
    fillInAll() {
        return this._senderPerson !== null && this.nextApprover !== null
    }

    getPersonAll(){
        const { _senderPerson,_nextApprover } = this
        if (this.fillInAll()) {
            return [_senderPerson,_nextApprover]
        }
        return [_senderPerson]
    }

    get detailControl() {
        return this._detailControl;
    }

    set detailControl(value) {
        this._detailControl = value;
    }

    get nextApprover() {
        return this._nextApprover;
    }

    get senderPerson() {
        return this._senderPerson;
    }

    set senderPerson(value) {
        this._senderPerson = value;
    }

    set nextApprover(value) {
        this._nextApprover = value;
    }
}

let container;

const LoadComponents = (detailControl) => {
    container = new Container(detailControl)
}

/**
 * 根据类型填充节点
 * @param type
 * @param user
 */
const fillPerson = (type,user) => {

    switch (type) {
        case "台账负责人":
            container._nextApprover = user.id
            break
        case "第一步审批人":
            container._senderPerson = user.id
            break
    }
}

/**
 * 获取多选框中所有选择了的名称
 * @param control
 * @return {[string]}
 */
const getSelectorNames = (control) => {
    // 多选框选择的元素
    const values = control.ValuesSelect
    // 获取到多选框的Option
    let options = control.Config.Selector.Options
    //创建新的数组来装对应Option的名称
    let names = []
    for (const key of values) {
        let option = options.filter(e => e.Key === key)
        if (option.length !== 0) {
            let name = option[0].Value[0].Text
            names.push(name)
        }
    }
    return names
}

/**
 * 创建控件节点
 * @param control
 * @param excludeNames
 * @return {[]}
 */
const parseSelectorVal = (control,excludeNames) => {
    // 多选框选择的元素
    let names = getSelectorNames(control)
    names = difference(names,excludeNames)
    return container.createTables(names)
}


/**
 * 发送所需的实体
 * @param empNo
 * @param nextPerson
 * @return {string}
 */
const sendUrl = (empNo,nextPerson,isLegal) => {
    return `FirstHandEarlyWarningCheck?templateId=C4RYPCDYWy9gySNmqyf9r5oq42TuscVb2q2BoKVTv&empNo=${empNo}&nextApprover=${nextPerson}&isLegal=${isLegal}`
    // return `FirstHandEarlyWarningCheck?templateId=C4RbxnuziY4ajmHbLpo9v3BS52jrStcvGJGMavhLr&empNo=${empNo}&nextApprover=${nextPerson}&isLegal=${isLegal}`
}


const select = (arr,callback) => {
    let results = []
    for (const v of arr) {
        const result = callback(v)
        if(result !== null && result !== undefined) {
            results.push(result)
        }
    }
    return results
}




/**
 * 差集
 * @param arr
 * @return {[]}
 */
const difference = (arr1,arr2) => {
    let set1 = new Set(arr1);
    let set2 = new Set(arr2);
    let subset = [];
    if (set1.size >= set2.size){
        for (let item of set1) {
            if (!set2.has(item)) {
                subset.push(item);
            }
        }
    }else{
        for (let item of set2) {
            if (!set1.has(item)) {
                subset.push(item);
            }
        }
    }
    return subset;
}

/**
 * 交集
 * @param arr
 * @return {*}
 */
const union =  (arrs1,arrs2) => {
    let arr1 = new Set(arrs1)
    let arr2 = new Set(arrs2)
    const results = []
    for (let i1 of arr1) {
        if(arr2.has(i1)){
            results.push(i1)
        }
    }
    return results
}

export {
    LoadComponents,
    parseSelectorVal,
    getSelectorNames,
    select,
    difference,
    union,
    fillPerson,
    sendUrl
}

